import React, { ErrorInfo, PropsWithChildren } from 'react';
import { Logger } from 'loglevel';
import { getLogger } from '../logger/logger';

type State = {
  error?: Error;
  errorInfo?: React.ErrorInfo;
};
type Props = {
  loggerName?: string;
  fallback?: (error?: Error, errorInfo?: React.ErrorInfo) => React.ReactElement;
};
export class ErrorBoundary extends React.Component<PropsWithChildren<Props>, State> {
  log: Logger;
  constructor(props: Props) {
    super(props);
    this.log = getLogger(props.loggerName ?? 'ErrorBoundary');
  }
  static getDerivedStateFromError(error: Error, errorInfo: ErrorInfo) {
    return { error, errorInfo };
  }
  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.log.error('caught error in boundary', { error, errorInfo });
  }

  render() {
    if (this.state?.error) {
      return this.props.fallback?.(this.state.error, this.state?.errorInfo);
    }

    return this.props.children;
  }
}
